/**
 * Redux action type constants for audio management.
 *
 * Defines all constant string types used for audio-related Redux actions,
 * including list operations (reset, set, clear) and playback controls (play, pause, stop).
 *
 * @module audioTypes
 * @author AI Assistant
 * @version 1.0.0
 */
export const RESET_LIST = 'RESET_LIST',
    SET_LIST = 'SET_LIST',
    SET_LIST_TYPE = 'SET_LIST_TYPE',
    CLEAR_LIST = 'CLEAR_LIST',
    PLAY_LIST = 'PLAY_LIST',
    PAUSE_LIST = 'PAUSE_LIST',
    STOP_LIST = 'STOP_LIST',
    PLAY_AUDIO = 'PLAY_AUDIO',
    PAUSE_AUDIO = 'PAUSE_AUDIO',
    STOP_AUDIO = 'STOP_AUDIO';
